module.exports = __webpack_public_path__ + "static/assets/e470729e562677fc6b1338a6a1dbd819.png";